/* eslint-disable import/prefer-default-export */
import * as types from '../constants/ActionTypes';
import { contactPage, suggestTopics, chatBotContactTo } from '../constants/UtilVariables';
import { fetchPhoneNumber } from './action-call-us';
import getTopicTree from '../../home/actions/action-topic-list';
import { accessLogoutEmail } from './action-email-no-intent';
import { fetchTopicTree } from '../actions/action-message-topic-tree';
import { fetchRelatedTopic } from './action-quick-answer-topics';
import { isLoggedIn, getLogoutEmailRefId, getChatBotContactTo, isAUPHardcodeFormEnabled } from '../../lib/page';
import { fetchPPCEnable } from './action-ppc-checker';
import { fetchChatBotSessionChecker } from './action-chat-bot';
import { providePPMEmailFields } from './action-paypalme-email';

export const redirecLocation = ({ pageName }) => ({
  type: types.CONTACT_LOCATION_CHANGE,
  payload: { pageName },
});

// Fetch data for Call Page
function fetchCallPageRequests() {
  return (dispatch) => {
    dispatch(fetchPhoneNumber());

    if (isLoggedIn()) {
      dispatch(fetchPPCEnable());
    }
  };
}

// fetch data for Email Page
function fetchEmailPageRequests(options) {
  return (dispatch) => {
    // Using Hardcode webform data for PayPalMe controlled by remote config
    if (isAUPHardcodeFormEnabled()) {
      dispatch(providePPMEmailFields());
    } else {
      dispatch(fetchTopicTree(options));
    }

    dispatch(getTopicTree());
    dispatch(fetchRelatedTopic(suggestTopics.email));
  };
}

// Redirect to Call or Email page based on current pageName
function redirectToCallOrEmail(pageName) {
  return (dispatch) => {
    if (pageName === contactPage.callUs) {
      dispatch(fetchCallPageRequests()); // Fetch data for Call Us
    } else if (pageName === contactPage.email) {
      dispatch(fetchEmailPageRequests({ email: true })); // Fetch data for Email Page
    } else {
      // Loading Topic tree data in the Contact landing page
      dispatch(fetchTopicTree());
    }
  };
}

function checkChatBotSession(redirect = {}) {
  return (dispatch) => {
    const chatBotQuery = getChatBotContactTo();

    // Login and chatBot checker;
    if (!chatBotQuery || !isLoggedIn()) {
      return redirect.default(); // default redirect logic
    }

    // Chat Bot Session checker
    // conditions: if the response 'chatEnded' is equal to false and 'sessionType' to 'chatBot'
    const chatBotSessionChecker = responseData => (
      (responseData && responseData.sessionModule
      && (responseData.sessionModule.chatEnded === false)
      && (responseData.sessionModule.sessionType === 'chatBot'))
      || (responseData && responseData.conversationId)
    );

    // Redirect to Call or Email page for ChatBot;
    const options = {};
    options.callBack = (responseData) => {
      if (!responseData || !chatBotSessionChecker(responseData)) {
        return redirect.default(); // default redirect
      } else if (chatBotContactTo.email === chatBotQuery) {
        return redirect.email(); // Email redirect
      } else if (chatBotContactTo.call === chatBotQuery) {
        return redirect.callUs(); // Call redirect
      }
      return redirect.default(); // default redirect if the chatBotQuery is not validate
    };

    return dispatch(fetchChatBotSessionChecker(options));
  };
}

// Check Current location and send API request for different locations
export const locationChecker = () => (dispatch, getState) => {
  const state = getState();
  const { location: { pageName } } = state;

    // query checker for logout Email; have validate refId for `email` query
  const emailRef = getLogoutEmailRefId();
  if (emailRef) {
      // Redirect to Logout Webform
    dispatch(redirecLocation({ pageName: contactPage.email }));
    dispatch(fetchEmailPageRequests({ emailRef, logoutEmail: true }));
    dispatch(accessLogoutEmail());
  } else {
    const redirect = { // ChatBot redirect switcher
      default: () => {
        dispatch(redirectToCallOrEmail(pageName));
      },
      email: () => {
        dispatch(redirecLocation({ pageName: contactPage.email }));
        dispatch(fetchEmailPageRequests({ email: true }));
      },
      callUs: () => {
        dispatch(redirecLocation({ pageName: contactPage.callUs }));
        dispatch(fetchCallPageRequests());
      },
    };

      // Check chatBot query and chatBot session data
    dispatch(checkChatBotSession(redirect));
  }

  return {
    type: types.CONTACT_LOCATION_LOAD,
  };
};

// Update current location action, if users go to Email/CallUs page/Channel Steering
export const locationUpdate = ({ pageName }) => (dispatch) => {
  if (pageName) {
    dispatch(redirecLocation({ pageName }));
    dispatch(locationChecker());
  }
};
